export type AppRole = "customer" | "business_customer" | "driver";

export type RegistrationType =
  | "private_customer"
  | "business_customer"
  | "operator";

export function registrationTypeToRole(type: RegistrationType): AppRole {
  if (type === "operator") {
    return "driver";
  }

  if (type === "business_customer") {
    return "business_customer";
  }

  return "customer";
}

export function isCustomerRole(role?: AppRole | string | null): boolean {
  return role === "customer" || role === "business_customer";
}

export function isDriverRole(role?: AppRole | string | null): boolean {
  return role === "driver";
}

export function getRoleLabel(role?: AppRole | string | null): string {
  if (role === "business_customer") {
    return "Business Customer";
  }

  if (role === "driver") {
    return "Driver";
  }

  return "Customer";
}

export const REGISTRATION_LABELS: Record<RegistrationType, string> = {
  private_customer: "Private customer",
  business_customer: "Business customer",
  operator: "Operator",
};

export function isRegistrationType(
  value?: string | null
): value is RegistrationType {
  return (
    value === "private_customer" ||
    value === "business_customer" ||
    value === "operator"
  );
}

export function isAppRole(value?: string | null): value is AppRole {
  return (
    value === "customer" ||
    value === "business_customer" ||
    value === "driver"
  );
}
